/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { buildInfo } from './environments/build-info';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Log the build stamp so you can confirm from the browser console exactly which
// build is live (helps catch stale caches after a deploy).
// eslint-disable-next-line no-console
console.info(
  `%c${environment.appName} build ${buildInfo.version} · ${buildInfo.commit} · ${buildInfo.branch} · ${buildInfo.buildTime}`,
  'color:#009ef7;font-weight:600;'
);

// Errors thrown outside Angular's zone (third-party scripts, socket callbacks,
// chunk-load failures) never reach Angular's ErrorHandler. Log them here.
window.addEventListener('error', (e) =>
  console.error('[cornerstone] window error:', e.error ?? e.message)
);
window.addEventListener('unhandledrejection', (e) =>
  console.error('[cornerstone] unhandled promise rejection:', e.reason)
);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error('[cornerstone] bootstrap failed:', err));
